<template>
    <div class="d-flex solicitar-selfie-wrapper">
        <div class="d-flex align-center solicitar-selfie">
            <span class="solicitar-selfie-label">{{ label }}</span>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <span v-on="on">
                        <v-icon size="13px">mdi-information</v-icon>
                    </span>
                </template>
                <span>{{ informacao }}</span>
            </v-tooltip>
        </div>

        <v-switch
            class="ma-0 pa-0"
            color="primary"
            dense
            hide-details
            v-model="value.solicitarSelfieAssinatura"
            :disabled="desabilitarCampo"
        />
    </div>

</template>

<script>
export default {
    name: 'SwitchSolicitarSelfieAssinatura',
    props: {
        value: {
            required: true
        },
        desabilitarCampo: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            required: true
        },
        informacao: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="stylus" scoped>
.solicitar-selfie-wrapper
    justify-content space-between

    .solicitar-selfie
        gap 5px

        .solicitar-selfie-label
            color var(--text-color-300)
            font-size 16px
</style>
